export const USER_ROLES = {
  VIEWER: 'viewer',
  PARTICIPANT: 'participant',
  LEADER: 'leader',
};

export const USER_ROLES_NAMES = {
  [USER_ROLES.VIEWER]: 'Dashboard Viewer',
  [USER_ROLES.PARTICIPANT]: 'Survey Participant',
  [USER_ROLES.LEADER]: 'Project Leader',
};

export const USER_ROLES_SHORT_NAMES = {
  [USER_ROLES.VIEWER]: 'Viewer',
  [USER_ROLES.PARTICIPANT]: 'Participant',
  [USER_ROLES.LEADER]: 'Leader',
};

export const USER_ROLES_CAPTIONS = {
  invitationBlockTitle:
    'Here you can bulk-add new users to your cultural project by copying and pasting their email address.',
  permissionsTitle:
    'Make sure you tick the correct permissions you would like each user you are adding to have. The permissions you tick can be a combination of survey participants, dashboard viewers and project leaders.',
  [USER_ROLES.VIEWER]: 'Dashboard Viewers will have access to view the dashboard.',
  [USER_ROLES.PARTICIPANT]: 'Survey Participants will have access to submit surveys.',
  [USER_ROLES.LEADER]: 'Project leaders will have admin access to manage the project.',
};

export const orderedUserRoles = [USER_ROLES.VIEWER, USER_ROLES.PARTICIPANT, USER_ROLES.LEADER];
